import React from "react";
import BorderedButton from "../../../Buttons/BorderedButton";
import PrimaryButton from "../../../Buttons/PrimaryButton";
import styles from "./Style.module.css";

const RefundStep = ({ paymentDetails, nextStep, previousStep, loading, heading }) => {
	const isLoading = loading || paymentDetails === null;
	const payments = Array.isArray(paymentDetails) ? paymentDetails : [];
	const formatAmount = (payment) => {
		const amount = Number(payment?.amount_value || 0).toFixed(2);
		return `${payment?.amount_currency === "SGD" ? "$" : ""}${amount}`;
	};
	const cashlessPayments = payments.filter((payment) => payment?.payment_method_slug?.toLowerCase() === "cashless");
	const otherMembershipPayments = payments.filter((payment) => payment?.payment_method_slug?.toLowerCase() === "other_membership");
	const originalPaymentMethods = payments.filter((payment) => {
		const method = payment?.payment_method_slug?.toLowerCase();
		return method && method !== "cashless" && method !== "other_membership";
	});

return (	
    <div className={`${styles.refundStep} popup`}>
		<div className="header">
			<h2>{heading}</h2>
			<p>This refund will be recorded in sales report.</p>
		</div>

		<div className="body">
			{isLoading ? (
				<div className={styles.loading}>Loading...</div>
			) : paymentDetails && paymentDetails.length > 0 ? (
				<>
					{cashlessPayments.length > 0 && (
						<RefundGroup title="Refund to cashless balance" payments={cashlessPayments} formatAmount={formatAmount} />
					)}
					{otherMembershipPayments.map((payment, index) => (
						<RefundGroup
							key={`${payment?.membership_transaction_id || payment?.membership_number || index}-membership`}
							title={`Refund to others membership${payment?.membership_number ? `(#${payment.membership_number})` : ""}`}
							payments={[payment]}
							formatAmount={formatAmount}
						/>
					))}
					{originalPaymentMethods.length > 0 && (
						<RefundGroup title="Refund to original payment method" payments={originalPaymentMethods} formatAmount={formatAmount} />
					)}
				</>
			) : (
				<div className={styles.loading}>No refundable payments found.</div>
			)}
		</div>

		<div className="footer">
			{/* <BorderedButton 
                text={skipButtonText}
                onClick={voidSale}
                disabled={skipRefundDisabled}
            /> */}
			{typeof previousStep === "function" && (
				<BorderedButton 
					text="Back"
					onClick={previousStep}
				/>
			)}
			<PrimaryButton
				text="Next"
				onClick={nextStep}
			/>
		</div>
	</div>
)};

const RefundGroup = ({ title, payments, formatAmount }) => (
	<div className={styles.refundGroup}>
		<div className={styles.groupTitle}>
			{/* <span className={styles.radioIndicator} /> */}
			<h6>{title}</h6>
		</div>
		{payments.map((payment, index) => (
			<div key={`${payment?.payment_method_id || payment?.payment_method}-${index}`} className={styles.card}>
				<div>{payment?.payment_method}</div>
				<div>{formatAmount(payment)}</div>
			</div>
		))}
	</div>
);

export default RefundStep;
